import React, { HTMLAttributes } from 'react'
import classnames from 'classnames'
import styles from './styles.css'

interface BottomAppBarProps extends HTMLAttributes<HTMLDivElement> {}

const BottomAppBar: React.SFC<BottomAppBarProps> = ({ className, ...rest }) => {
  return <div className={classnames(className, styles.appBar)} {...rest} />
}

export default BottomAppBar
